import { useState } from "react";
import Input from "../Input/Input";
import Button from "../Button/Button";
import Divider from "../Divider/Divider";
import { useSharedLists } from "../../context/SharedListContext";

export default function InviteUserForm({ list, onClose }) {
    const { inviteUser } = useSharedLists();
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [inviteLink, setInviteLink] = useState("");

    const handleInvite = async (e) => {
        e.preventDefault();
        if (!email.trim()) {
            setError("Email is required");
            return;
        }
        setError("");

        try {
            const link = await inviteUser(list.id, email);
            setInviteLink(link);
            setEmail("");
        } catch (err) {
            console.error("Error generating invite:", err);
            setError("Failed to create invite link.");
        }
    };

    return (
        <div>
            <h1 className="text-xl font-bold mb-2">
                Invite Users to {list.name}
            </h1>
            <p className="text-sm mb-3">
                Generate a link to send and invite a user to your list.
            </p>

            <Divider className="mb-4" />

            <form onSubmit={handleInvite} className="space-y-4">
                <Input
                    label="User's Name"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    error={error}
                />

                <div className="flex justify-end gap-4 pt-4">
                    <Button type="button" variant="ghost" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button type="submit" variant="primary">
                        Invite
                    </Button>
                </div>
            </form>

            {inviteLink && (
                <p className="my-4">
                    Invite link created! You can send this link directly to the user:{" "}
                    <a href={inviteLink} className="underline text-primary">
                        {inviteLink}
                    </a>
                </p>
            )}
        </div>
    );
}
